<template>
  <div>
       <div class="item-class display-flex" v-for="(item, index) in classLists" :key="index">
            <div class="info-left display-flex">
                <img src="@/assets/img/icon-list.png" alt />
                <div class="info-class text-left">
                    <h2 class="primary-color font-sanpro-semibold font-size-16">{{item.nameSubject}}</h2>
                    <h3
                        class="secondary-color-txt font-family-Semibold font-size-14"
                    >{{item.nameSchool}}</h3>
                    <h3 class="secondary-color-txt font-family-Semibold font-size-14">Mã lớp: <router-link class="primary-color font-sanpro-semibold font-size-14" to="/lop-hoc/ma-lop">{{item.classCode}}</router-link></h3>
                </div>
            </div>
        </div>
        <div class="status-join display-flex">
            <div class="form-group select-status">
                <select class="form-control" id="status">
                    <option>Đã tham gia</option>
                    <option>Chưa tham gia</option>
                    <option>Đã hoàn thành</option>
                </select>
                <i class="fa fa-angle-down"></i>
            </div>
            <div class="dropdown dropdown-account">
                <button
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    class="dropdown-toggle"
                >
                    <i class="fas fa-ellipsis-h"></i>
                </button>
                <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                    <a href="javascript:;" class="dropdown-item" role="button">Xem thông tin</a>
                    <a href="javascript:;" class="dropdown-item" role="button">Rời lớp</a>
                    <a href="javascript:;" class="dropdown-item" role="button">Báo cáo</a>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
export default {
    name: "InfoClassLeft",
    data(){
        return{
        }
    },
    components: {
    },
    computed: {
        ...mapGetters({
            classLists: STORE_KEY + "/classLists"
        })
    },
    mounted() {
          this.actionGetListClass();
    },
    methods: {
        ...mapActions(`${STORE_KEY}`, ["actionGetListClass"]),
    }
}

</script>

<style lang="scss" scoped>
   
   .dropdown-account{
        margin-left: 10px;
    }
    .dropdown button {
        width: 30px;
        background:#f3f6fb;
        color: #879AA9;
        font-size: 14px;
        text-align: center;
        border: 0px;
        padding-left: 0px;
        padding-right: 0px;
        border-radius: 30px;
        height: 30px;
        outline: 0;
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
        color: #124abe;
        text-decoration: none;
        background: #f3f6fb;
    }
    .dropdown button:focus {
        background: #f3f6fb !important;
        color: #124ABE;
    }
    .dropdown-toggle::after {
        display:none;
    }
    .dropdown-menu {
        padding: 0rem 0 0.5rem;
        margin: 0.125rem 0 0;
        box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
        transform: translate3d(-95px, 30px, 0px) !important;
    }
    @media (max-width: 425px){
        .dropdown-menu {
            padding: 0rem 0 0.5rem;
            margin: 0.125rem 0 0;
            box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
            transform: translate3d(167px, 30px, 0px) !important;
        }
    }
</style>